import * as React from "react";
import type { SVGProps } from "react";
const SvgEnvelope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 20h14c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3H5C3.35 4 2 5.35 2 7v10c0 1.65 1.35 3 3 3m.517-14L12 11.67 18.483 6zM20 7.328V17c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7.328l7.34 6.422c.19.17.42.25.66.25s.47-.08.66-.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEnvelope;
